import React from "react";
import { useTranslation } from "react-i18next";
import { Navvbar } from "../../components";

const PHeader = (props) => {
    const { t } = useTranslation();

    const navItems = [
        // {
        //     title: 'How it works',
        //     items: [
        //         { label: 'option 1', path: '/option1' },
        //         { label: 'option 2', path: '/option2' },
        //         { label: 'option 3', path: '/option3' },
        //         { label: 'option 4', path: '/option4' },
        //     ],
        // },
        { title: "Book Appointment", link: "book-an-appointment/specialist-list" },
        { title: "Chat with Specialist", link: "chat-with-specialist" },
        { title: "Emergency", link: "emergency" },
        { title: "Help", link: "help" },
    ];
    return (
        <Navvbar.Navvbar
            brandName="ExaDo"
            imgLink="/"
            navItems={navItems}
            className="pheader"
            userType="doctor"
            onPathClick={() => props.handlePath("/patient/login")}
            {...props}
        />
    )
}

export default PHeader;
